'use client'

import { useState, useEffect } from 'react'

export function useThemeSync(propIsDark?: boolean) {
    const [isDark, setIsDark] = useState<boolean>(propIsDark ?? true)
    const [isHydrated, setIsHydrated] = useState(false)

    useEffect(() => {
        // If isDark is explicitly passed as a prop, use it and don't randomise
        if (propIsDark !== undefined) {
            setIsDark(propIsDark)
            document.body.setAttribute('data-theme', propIsDark ? 'dark' : 'light')
            setIsHydrated(true)
            return
        }

        // Check sessionStorage to see if we've already picked a theme for this session
        const sessionTheme = sessionStorage.getItem('hero-is-dark')
        let currentTheme: boolean

        if (sessionTheme !== null) {
            currentTheme = sessionTheme === 'true'
        } else {
            // Pick randomly and save for this session
            currentTheme = Math.random() > 0.5
            sessionStorage.setItem('hero-is-dark', String(currentTheme))
        }

        setIsDark(currentTheme)
        setIsHydrated(true)
    }, [propIsDark])

    return { isDark, isHydrated }
}
